export default __webpack_public_path__ + "static/media/red_base.89417df1.png";